import { createHelpers } from 'vuex-map-fields';

const { getUserField, updateUserField } = createHelpers({
	getterType: `getUserField`,
	mutationType: `updateUserField`,
});


const state = {
	module: {
		is_load: false,
	},
	user: {
		id: 0,
		client_id:0,
		guest: 1,
		phone: 380,
		is_auth: false,
		status: "need_sms",
		need_captcha: true
	},
};

const getters = {

	getUser(state) {
		return state.user;
	},

	getUserModule(state) {
		return state.module;
	},

	getUserField,

};

// actions
const actions = {
	async LOAD_USER({commit}) {
		state.module.is_load = true;
		await api.get('/internal/user',{
			'headers' : {
				'Authorization': 'Bearer demo'
			}
		}).then(({data}) => {
			state.module.is_load = false;
			if(data.status === "operation_success") {
				state.user = {...state.user,...data.data};
				EventBus.$emit('user_added', state.user);

                try {
                    window.Echo.private("customer." + state.user.client_id)
                        .listen('.order.add', (e) => {
                            EventBus.$emit('new_order_in', e);
                            console.log(e);
                        });
                }
                catch (e) {

                }


            }
		}).catch(e => {
			console.log(e);
		})
	},

    async LOAD_FULL_USER({commit}) {
        state.module.is_load = true;
        await api.get('/internal/profile/user',{
            'headers' : {
                'Authorization': 'Bearer demo'
            }
        }).then(({data}) => {
            state.module.is_load = false;
            if(data.status === "operation_success") {
                state.user = {...state.user,...data.data};
                EventBus.$emit('profile_loaded', state.user);
            }
        }).catch(e => {
            console.log(e);
        })
    }
};

// mutations
const mutations = {
	updateUserField,

	addUser(state,data) {
		state.user = data;
		EventBus.$emit('user_added', data);
		state.module.is_load = true;
	},

	setUserField(state,data) {
		state.user = {...state.user,...data};
	},


};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
}
